import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  NgForm,
} from '@angular/forms';
import { ComponentBase } from '../../../../../../shared/models/component-base';
import { ConditionComponent } from '../condition/condition.component';

export const RADIO_FILTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => RadioFilterConditionComponent),
  multi: true,
};

@Component({
  selector: 'shared-radio-filter-condition',
  templateUrl: './radio-filter-condition.component.html',
  styleUrls: ['./radio-filter-condition.component.css'],
  providers: [RADIO_FILTER_VALUE_ACCESSOR],
})
export class RadioFilterConditionComponent
  extends ComponentBase
  implements ControlValueAccessor, AfterViewInit
{
  selectedOption: string | number;

  @Input() options: Array<{ text: string; value: any }>;
  @Input() userView: any;
  @Input() optionsFormControl: AbstractControl;

  /** Variable para utilizar el componente de condición */
  @ViewChild('condition', { static: true }) condition: ConditionComponent;

  /** Variable para utilizar el componente de búsqueda */
  @ViewChild('frm') frm: NgForm;

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
  }

  writeValue(obj: any): void {
    this.condition.writeValue(obj);
  }

  onRadioButtonClick(value: string): void {
    if (value === this.selectedOption) {
      this.optionsFormControl.setValue(null);
      this.selectedOption = null;
      return;
    }

    this.optionsFormControl.setValue(value);
    this.selectedOption = value;
    this.condition.changeCondition({
      value: this.selectedOption,
      text: this.options.find((option) => option.value === value).text,
    });
  }

  registerOnChange(fn: any): void {
    this.condition.registerOnChange(fn);
  }

  registerOnTouched(fn: any): void {
    this.condition.registerOnTouched(fn);
  }

  abstractToFormControl(control: AbstractControl): FormControl {
    return control as FormControl;
  }
}
